// frontend/src/components/shared/ConfirmDialog.jsx
// Styled replacement for window.confirm() — matches the admin panel look
// (solid bgGradient background, gold border, no translucency).
import { useState, useCallback } from 'react';
import { colors, fontFamily } from '../../theme';

export function useConfirm() {
  const [confirmState, setConfirmState] = useState(null); // { message, resolve }
  const confirm = useCallback((message) => (
    new Promise((resolve) => setConfirmState({ message, resolve }))
  ), []);
  const resolveConfirm = (result) => {
    setConfirmState((prev) => {
      if (prev) prev.resolve(result);
      return null;
    });
  };
  return { confirmState, confirm, resolveConfirm };
}

export default function ConfirmDialogHost({ confirmState, resolveConfirm, confirmLabel = 'Confirm', cancelLabel = 'Cancel' }) {
  if (!confirmState) return null;
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 300, padding: '1rem',
      }}
    >
      <div
        style={{
          background: colors.bgGradient,
          border: `1px solid ${colors.goldMuted}`,
          borderRadius: 8,
          maxWidth: '28rem',
          width: '100%',
          padding: '1.25rem',
          fontFamily,
        }}
      >
        <p style={{ color: colors.textPrimary, margin: 0, fontSize: '0.95rem', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
          {confirmState.message}
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1.25rem' }}>
          <button
            onClick={() => resolveConfirm(false)}
            style={{ background: 'none', border: `1px solid ${colors.goldMuted}`, color: colors.textPrimary, borderRadius: 6, padding: '0.5rem 1.25rem', cursor: 'pointer', fontWeight: 600, fontFamily }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={() => resolveConfirm(true)}
            style={{ background: colors.goldActiveBg, border: `1px solid ${colors.gold}`, color: colors.textPrimary, borderRadius: 6, padding: '0.5rem 1.25rem', cursor: 'pointer', fontWeight: 700, fontFamily }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
